import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/* Componente customizable que permite pasar una funcion onConfirm, onCancel y un mensaje para modal que necesitan un boton con variante danger (puede ser extendido de ser necesario) */
const ConfirmationModal = ({ show, onConfirm, onCancel, message }) => {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmación adicional</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
